import PropTypes from 'prop-types';
import { memo } from 'react';
import { StyledSelect } from './styles';
Select.propTypes = {
    children: PropTypes.node,
    sx: PropTypes.object
};
function Select({ children, sx, placeholder, ...other }) {
    return (
        <StyledSelect
            {...other}
            sx={{
                '& .MuiSelect-select .notranslate::after': placeholder
                    ? {
                        content: `"${placeholder}"`,
                        opacity: 0.7
                    }
                    : {},
                ...sx
            }}
        >
            {children}
        </StyledSelect>
    );
}

export default memo(Select);
